<template>
  <div class="report-page">
    <div class="back_box">
      <div class="back_btn" @click="backPage">
        <img src="https://resources.sxsaas.com/static/jigou-saas-app/jiantou.png" alt="">
        <div class="text">返回</div>
      </div>
      <div class="class_name">{{ stageName }} - 报告列表</div>
    </div>
    <div class="main_box">
      <!-- 顶部信息条 -->
      <div class="info_bar" v-if="reportList.length > 0">
        <div class="info_left">
          <div class="info_icon">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="#747DFE" stroke-width="2">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
              <polyline points="14 2 14 8 20 8"/>
            </svg>
          </div>
          <span class="info_text">共 <strong>{{ total }}</strong> 份报告</span>
        </div>
        <div class="info_right" v-if="total > pageSize">
          第 {{ currentPage }} / {{ Math.ceil(total / pageSize) }} 页
        </div>
      </div>

      <div class="report_list" v-if="reportList.length > 0">
        <div class="report_item" v-for="(item, index) in reportList" :key="item.id" @click="openReport(item)">
          <div class="report_index">{{ String(index + 1).padStart(2, '0') }}</div>
          <div class="report_icon_wrap">
            <div class="report_icon" :class="getIconClass(item.report_type_label)">
              <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="#fff" stroke-width="1.8">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                <polyline points="14 2 14 8 20 8"/>
                <line x1="16" y1="13" x2="8" y2="13"/>
                <line x1="16" y1="17" x2="8" y2="17"/>
              </svg>
            </div>
          </div>
          <div class="report_info">
            <div class="report_title">{{ item.title }}</div>
            <div class="report_desc">{{ item.description || '暂无描述' }}</div>
            <div class="report_meta">
              <span class="report_type" :class="'type_' + getIconClass(item.report_type_label)">{{ item.report_type_label }}</span>
              <span class="report_time">
                <svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" style="vertical-align: -1px; margin-right: 3px;">
                  <circle cx="12" cy="12" r="10"/>
                  <polyline points="12 6 12 12 16 14"/>
                </svg>
                {{ formatTime(item.create_time) }}
              </span>
            </div>
          </div>
          <div class="report_action">
            <span class="view_btn">
              <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" style="vertical-align: -2px; margin-right: 4px;">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                <circle cx="12" cy="12" r="3"/>
              </svg>
              查看报告
            </span>
          </div>
        </div>
      </div>
      <div class="empty_box" v-else-if="!loading">
        <div class="empty_icon_wrap">
          <svg viewBox="0 0 80 80" width="80" height="80" fill="none">
            <rect x="12" y="8" width="56" height="64" rx="6" stroke="#d0d5e8" stroke-width="2"/>
            <line x1="24" y1="24" x2="56" y2="24" stroke="#d0d5e8" stroke-width="2" stroke-linecap="round"/>
            <line x1="24" y1="34" x2="48" y2="34" stroke="#d0d5e8" stroke-width="2" stroke-linecap="round"/>
            <line x1="24" y1="44" x2="40" y2="44" stroke="#d0d5e8" stroke-width="2" stroke-linecap="round"/>
            <circle cx="56" cy="56" r="14" fill="#f0f2ff" stroke="#d0d5e8" stroke-width="2"/>
            <line x1="50" y1="56" x2="62" y2="56" stroke="#d0d5e8" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </div>
        <div class="empty_text">暂无报告</div>
        <div class="empty_sub">该分组下还没有生成报告</div>
      </div>
      <div class="pagination_box" v-if="total > pageSize">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="pageSize"
          :current-page.sync="currentPage"
          @current-change="fetchReports">
        </el-pagination>
      </div>
    </div>
    <div class="page_end_fixed">
      <endBox></endBox>
    </div>
  </div>
</template>

<script>
import * as openReportApi from '@/api/openReport.js'

export default {
  data() {
    return {
      reportList: [],
      loading: true,
      currentPage: 1,
      pageSize: 15,
      total: 0,
      stageName: ''
    }
  },
  created() {
    this.stageName = this.$route.query.stage_name || ''
    this.fetchReports()
  },
  methods: {
    async fetchReports() {
      this.loading = true
      try {
        var proId = this.$route.query.pro_id || window.localStorage.getItem('proID')
        var stageId = this.$route.query.stage_id
        var user = JSON.parse(window.localStorage.getItem('user') || '{}')
        var stuId = user.stu_id || 0
        var res = await openReportApi.getStudentReports(proId, stuId, {
          stage_id: stageId,
          page: this.currentPage,
          page_size: this.pageSize
        })
        if (res.data.code === 200) {
          this.reportList = res.data.data.data || []
          this.total = res.data.data.total || 0
        }
      } catch (e) {
        console.error('获取报告列表失败', e)
        this.$message({ message: '获取报告列表失败', type: 'error' })
      } finally {
        this.loading = false
      }
    },
    openReport(item) {
      if (!item.file_url) {
        this.$message({ message: '报告文件不存在', type: 'warning' })
        return
      }
      var url = item.file_url
      if (url.startsWith('/')) {
        url = 'http://ops.xinghan.cloud' + url
      }
      window.open(url, '_blank')
    },
    getIconClass(typeLabel) {
      if (!typeLabel) return 'default'
      if (typeLabel.indexOf('期末') >= 0) return 'final'
      if (typeLabel.indexOf('期中') >= 0) return 'mid'
      if (typeLabel.indexOf('单元') >= 0) return 'unit'
      if (typeLabel.indexOf('月考') >= 0) return 'monthly'
      return 'default'
    },
    formatTime(timestamp) {
      if (!timestamp) return ''
      var date = new Date(timestamp * 1000)
      var y = date.getFullYear()
      var m = String(date.getMonth() + 1).padStart(2, '0')
      var d = String(date.getDate()).padStart(2, '0')
      var h = String(date.getHours()).padStart(2, '0')
      var min = String(date.getMinutes()).padStart(2, '0')
      return y + '-' + m + '-' + d + ' ' + h + ':' + min
    },
    backPage() {
      this.$router.back()
    }
  }
}
</script>

<style scoped>
.report-page {
  background: #f0f2f8;
}
.back_box {
  width: 1160px;
  height: 60px;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%);
  margin: 20px auto 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0 24px;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(116, 125, 254, 0.08);
}
.back_btn {
  width: 95px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(122, 152, 249, 1);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.25s;
  color: #747DFE;
  font-size: 14px;
}
.back_btn:hover {
  background: rgba(116, 125, 254, 0.08);
  transform: translateX(-2px);
}
.back_btn img { width: 20px; height: 20px; }
.back_btn .text { margin-top: -1px; margin-left: 8px; }
.class_name {
  color: rgba(22, 27, 38, 1);
  font-weight: 700;
  font-size: 18px;
  letter-spacing: 0.5px;
}
.main_box {
  width: 1160px;
  margin: 0 auto;
  background: #fff;
  box-sizing: border-box;
  padding: 24px;
  min-height: 400px;
  border-radius: 12px;
  box-shadow: 0 2px 16px rgba(116, 125, 254, 0.06);
}

/* 信息条 */
.info_bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  background: linear-gradient(135deg, #f8f9ff 0%, #f0f2ff 100%);
  border-radius: 10px;
  margin-bottom: 20px;
}
.info_left { display: flex; align-items: center; gap: 10px; }
.info_icon {
  width: 36px;
  height: 36px;
  background: rgba(116, 125, 254, 0.1);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.info_text { font-size: 14px; color: #666; }
.info_text strong { color: #747DFE; font-size: 16px; }
.info_right { font-size: 13px; color: #a0a4b8; }

/* 报告列表 */
.report_list { display: flex; flex-direction: column; gap: 12px; }
.report_item {
  display: flex;
  align-items: center;
  padding: 18px 24px;
  background: #fafbff;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid transparent;
  position: relative;
}
.report_item:hover {
  background: #fff;
  border-color: rgba(116, 125, 254, 0.2);
  box-shadow: 0 4px 20px rgba(116, 125, 254, 0.1);
  transform: translateY(-1px);
}
.report_index {
  font-size: 13px;
  font-weight: 600;
  color: #c8cce0;
  margin-right: 14px;
  min-width: 24px;
}
.report_item:hover .report_index { color: #747DFE; }
.report_icon_wrap { margin-right: 16px; }
.report_icon {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s;
}
.report_item:hover .report_icon { transform: scale(1.05); }
.report_icon.default { background: linear-gradient(135deg, #747DFE 0%, #8B93FF 100%); }
.report_icon.final { background: linear-gradient(135deg, #FF7A7A 0%, #FF9A9A 100%); }
.report_icon.mid { background: linear-gradient(135deg, #FFB347 0%, #FFCC70 100%); }
.report_icon.unit { background: linear-gradient(135deg, #56C2E6 0%, #7DD4EE 100%); }
.report_icon.monthly { background: linear-gradient(135deg, #6DD47E 0%, #8EE49C 100%); }

.report_info { flex: 1; }
.report_title {
  font-size: 15px;
  font-weight: 600;
  color: #1e2330;
  margin-bottom: 6px;
  transition: color 0.2s;
}
.report_item:hover .report_title { color: #747DFE; }
.report_desc { font-size: 13px; color: #a0a4b8; margin-bottom: 8px; line-height: 1.4; }
.report_meta { display: flex; align-items: center; gap: 14px; }
.report_type {
  font-size: 12px;
  color: #747DFE;
  background: rgba(116, 125, 254, 0.08);
  padding: 3px 10px;
  border-radius: 6px;
  font-weight: 500;
}
.report_type.type_final { color: #FF7A7A; background: rgba(255, 122, 122, 0.08); }
.report_type.type_mid { color: #FFB347; background: rgba(255, 179, 71, 0.08); }
.report_type.type_unit { color: #56C2E6; background: rgba(86, 194, 230, 0.08); }
.report_type.type_monthly { color: #6DD47E; background: rgba(109, 212, 126, 0.08); }

.report_time {
  font-size: 12px;
  color: #b0b4c8;
}
.report_action { margin-left: 20px; }
.view_btn {
  font-size: 13px;
  color: #fff;
  background: linear-gradient(135deg, #747DFE 0%, #8B93FF 100%);
  padding: 8px 18px;
  border-radius: 8px;
  display: inline-block;
  transition: all 0.25s;
  white-space: nowrap;
  box-shadow: 0 2px 8px rgba(116, 125, 254, 0.25);
}
.report_item:hover .view_btn {
  background: linear-gradient(135deg, #5A64E0 0%, #747DFE 100%);
  box-shadow: 0 4px 12px rgba(116, 125, 254, 0.35);
  transform: translateY(-1px);
}

/* 空状态 */
.empty_box { text-align: center; padding: 80px 0; }
.empty_icon_wrap { margin-bottom: 20px; opacity: 0.7; }
.empty_text { color: #666; font-size: 16px; font-weight: 500; margin-bottom: 8px; }
.empty_sub { color: #b0b4c8; font-size: 13px; }

.pagination_box { margin-top: 24px; text-align: center; }
.page_end_fixed { width: 100%; margin-top: 20px; }
</style>
